import { useMemo } from 'react';
import { TransformUniqueValuesByColumnItem } from 'libs/end-to-end/src/types/databases/transform/transform-insights';

export function useJobTitleSuggestionsFromUniqueValues(
  uniqueValuesByColumn?: TransformUniqueValuesByColumnItem[],
): { jobTitleSuggestions: string[]; useJobTitleGroups: boolean } {
  return useMemo((): {
    jobTitleSuggestions: string[];
    useJobTitleGroups: boolean;
  } => {
    if (!uniqueValuesByColumn || uniqueValuesByColumn.length === 0) {
      return { jobTitleSuggestions: [], useJobTitleGroups: false };
    }

    const jobTitleGroupColumn = uniqueValuesByColumn.find(
      (c) => c.columnName === 'job_title_group_current',
    );

    if (
      jobTitleGroupColumn?.uniqueValues &&
      jobTitleGroupColumn.uniqueValues.length > 0
    ) {
      return {
        jobTitleSuggestions: jobTitleGroupColumn.uniqueValues,
        useJobTitleGroups: true,
      };
    }

    const jobTitleColumn = uniqueValuesByColumn.find(
      (c) => c.columnName === 'job_title',
    );
    return {
      jobTitleSuggestions: jobTitleColumn?.uniqueValues ?? [],
      useJobTitleGroups: false,
    };
  }, [uniqueValuesByColumn]);
}
